import Form from "../../form/Form";
import FormHeading from "../../form/FormHeading";
import FormInput from "../../form/FormInput";
import {useRef, useState} from "react";
import FormText from "../../form/FormText";
import FormCheckBox from "../../form/FormCheckBox";
import FormButton from "../../form/FormButton";
import Dialog from "../../general/dialog/Dialog";
import NewProductValidation from "../../../logic/vendor/newProductValidation";
import Popup from "../../../../components/general/popup/Popup";

const NewProductForm = () => {

    const [ useBrandBank, setUseBrandBank ] = useState(true);
    const [ warning, setWarning ] = useState();

    console.log(useBrandBank);

    const ref = useRef({});

    const setRefValue = (key) => (val) => {
        ref.current[key] = val;
    }


    const submit = () => {
        const valid = NewProductValidation.validate(ref.current);
        if(!valid.isValid) {
            setWarning(valid.msg);
        }
    }

    return (
        <>
            {warning &&
                <Popup>
                    <Dialog
                        title="Missing Data"
                        message={warning}
                        neutralButton={{name: "OK", onClick: () => setWarning(null)}}
                    />
                </Popup>
            }
            <Form>
                <FormHeading gridColumn="span 2">Product Details</FormHeading>
                <FormInput name="Name*" onValueChange={setRefValue("name")}/>
                <FormInput name="Supplier Code*"  onValueChange={setRefValue("code")}
                    gridColumn="1"/>
                <FormInput name="Case Barcode*"  onValueChange={setRefValue("caseCode")}
                    gridColumn="2" gridRow="2"/>
                <FormInput name="Inner Barcode*" onValueChange={setRefValue("innerCode")} />
                <FormInput name="Retail Code"  onValueChange={setRefValue("retailCode")}
                    gridColumn="2"/>
                <FormInput name="RRP" onValueChange={setRefValue("rrp")} gridColumn="1" gridRow="4"/>
                <FormCheckBox text="Price Marked" onValueChange={setRefValue("rrp")} gridColumn="1" gridRow="5"/>
            </Form>
            <Form>
                <FormHeading gridColumn="span 2">Purchase Info</FormHeading>
                <FormInput name="Wholsesale Price (not RRP)*" onValueChange={setRefValue("price")} />
                <FormInput name="Layer Quantity (units per pallet layer)" onValueChange={setRefValue("layer")} />
                <FormInput name="Full Pallet Quantity" onValueChange={setRefValue("pallet")}
                    gridColumn="2"/>
            </Form>
            <Form>
                <FormHeading gridColumn="span 2">Other</FormHeading>
                <FormInput name="Comments/ Notes" onValueChange={setRefValue("comments")}></FormInput>
            </Form>
            <Form>
                <FormHeading gridColumn="span 2">Branding Info</FormHeading>
                <FormText>If your product is listed with NIQ brandbank, we will be able to import branding data from there. </FormText>
                <FormCheckBox gridColumn={1} text={"Import From BrandBank"} defaultChecked={true} onCheckedChanged={setUseBrandBank} />
            </Form>
            {/*{!useBrandBank &&*/}
            {/*    <Form>*/}
            {/*        <FormHeading gridColumn="span 2">Brand Editor</FormHeading>*/}
            {/*        <FormFileUpload name="Upload Product Image" accept="image/*" onFileUploaded={setProductImage} />*/}
            {/*        <FormImage name="Image" src={productImage} imgStyle={{maxHeight: "340px", maxWidth: "340px"}} />*/}
            {/*        <FormItemCustom name="Brand Lines">*/}
            {/*            <BrandLineEditor />*/}
            {/*        </FormItemCustom>*/}
            {/*    </Form>*/}
            {/*}*/}
            <Form>
                <div style={{height: "100px", gridColumn: 2}}></div>
                <FormButton gridColumn={2} onClick={submit}>Submit For Review</FormButton>
            </Form>
            <div style={{height: "100px"}} />
        </>
    )

}

export default NewProductForm;